import { objectKeys } from "@kazoohr/helpers";

import { asyncComponent } from "../../helpers/asyncComponent";

import { IllustrationDictionary } from "./types";

/**
 * A map of all the illustrations available in the Confetti library, as async
 * components that are loaded as needed. Cuts down massively on initial load
 * times.
 */
export const IllustrationMap: Record<IllustrationDictionary, any> = {
  absenteeism: asyncComponent({
    module: () => import("./Illustrations/Absenteeism"),
    component: (module) => module.Absenteeism,
  }),
  activity_feed: asyncComponent({
    module: () => import("./Illustrations/ActivityFeed"),
    component: (module) => module.ActivityFeed,
  }),
  admin: asyncComponent({
    module: () => import("./Illustrations/Admin"),
    component: (module) => module.Admin,
  }),
  appreciation: asyncComponent({
    module: () => import("./Illustrations/Appreciation"),
    component: (module) => module.Appreciation,
  }),
  be_quick_dont_hurry: asyncComponent({
    module: () => import("./Illustrations/BeQuickDontHurry"),
    component: (module) => module.BeQuickDontHurry,
  }),
  brand_promise: asyncComponent({
    module: () => import("./Illustrations/BrandPromise"),
    component: (module) => module.BrandPromise,
  }),
  brand_vision: asyncComponent({
    module: () => import("./Illustrations/BrandVision"),
    component: (module) => module.BrandVision,
  }),
  challenge_accepted: asyncComponent({
    module: () => import("./Illustrations/ChallengeAccepted"),
    component: (module) => module.ChallengeAccepted,
  }),
  check_ins: asyncComponent({
    module: () => import("./Illustrations/CheckIns"),
    component: (module) => module.CheckIns,
  }),
  comments: asyncComponent({
    module: () => import("./Illustrations/Comments"),
    component: (module) => module.Comments,
  }),
  connections: asyncComponent({
    module: () => import("./Illustrations/Connections"),
    component: (module) => module.Connections,
  }),
  custom_question: asyncComponent({
    module: () => import("./Illustrations/CustomQuestion"),
    component: (module) => module.CustomQuestion,
  }),
  customer_success: asyncComponent({
    module: () => import("./Illustrations/CustomerSuccess"),
    component: (module) => module.CustomerSuccess,
  }),
  enps_survey: asyncComponent({
    module: () => import("./Illustrations/EnpsSurvey"),
    component: (module) => module.EnpsSurvey,
  }),
  feedback: asyncComponent({
    module: () => import("./Illustrations/Feedback"),
    component: (module) => module.Feedback,
  }),
  goal_task: asyncComponent({
    module: () => import("./Illustrations/GoalTask"),
    component: (module) => module.GoalTask,
  }),
  goals: asyncComponent({
    module: () => import("./Illustrations/Goals"),
    component: (module) => module.Goals,
  }),
  growth: asyncComponent({
    module: () => import("./Illustrations/Growth"),
    component: (module) => module.Growth,
  }),
  high_five: asyncComponent({
    module: () => import("./Illustrations/HighFive"),
    component: (module) => module.HighFive,
  }),
  home: asyncComponent({
    module: () => import("./Illustrations/Home"),
    component: (module) => module.Home,
  }),
  in_good_company: asyncComponent({
    module: () => import("./Illustrations/InGoodCompany"),
    component: (module) => module.InGoodCompany,
  }),
  incentives: asyncComponent({
    module: () => import("./Illustrations/Incentives"),
    component: (module) => module.Incentives,
  }),
  insights: asyncComponent({
    module: () => import("./Illustrations/Insights"),
    component: (module) => module.Insights,
  }),
  integrations: asyncComponent({
    module: () => import("./Illustrations/Integrations"),
    component: (module) => module.Integrations,
  }),
  know_your_audience: asyncComponent({
    module: () => import("./Illustrations/KnowYourAudience"),
    component: (module) => module.KnowYourAudience,
  }),
  launch: asyncComponent({
    module: () => import("./Illustrations/Launch"),
    component: (module) => module.Launch,
  }),
  management: asyncComponent({
    module: () => import("./Illustrations/Management"),
    component: (module) => module.Management,
  }),
  messages: asyncComponent({
    module: () => import("./Illustrations/Messages"),
    component: (module) => module.Messages,
  }),
  mobile: asyncComponent({
    module: () => import("./Illustrations/Mobile"),
    component: (module) => module.Mobile,
  }),
  nominations_and_awards: asyncComponent({
    module: () => import("./Illustrations/NominationsAndAwards"),
    component: (module) => module.NominationsAndAwards,
  }),
  okrs: asyncComponent({
    module: () => import("./Illustrations/Okrs"),
    component: (module) => module.Okrs,
  }),
  peer_to_peer: asyncComponent({
    module: () => import("./Illustrations/PeerToPeer"),
    component: (module) => module.PeerToPeer,
  }),
  performance_management: asyncComponent({
    module: () => import("./Illustrations/PerformanceManagement"),
    component: (module) => module.PerformanceManagement,
  }),
  processing: asyncComponent({
    module: () => import("./Illustrations/Processing"),
    component: (module) => module.Processing,
  }),
  productivity: asyncComponent({
    module: () => import("./Illustrations/Productivity"),
    component: (module) => module.Productivity,
  }),
  pulse_survey: asyncComponent({
    module: () => import("./Illustrations/PulseSurvey"),
    component: (module) => module.PulseSurvey,
  }),
  recognition: asyncComponent({
    module: () => import("./Illustrations/Recognition"),
    component: (module) => module.Recognition,
  }),
  retention: asyncComponent({
    module: () => import("./Illustrations/Retention"),
    component: (module) => module.Retention,
  }),
  rewards: asyncComponent({
    module: () => import("./Illustrations/Rewards"),
    component: (module) => module.Rewards,
  }),
  rewards_catalog: asyncComponent({
    module: () => import("./Illustrations/RewardsCatalog"),
    component: (module) => module.RewardsCatalog,
  }),
  security: asyncComponent({
    module: () => import("./Illustrations/Security"),
    component: (module) => module.Security,
  }),
  skills: asyncComponent({
    module: () => import("./Illustrations/Skills"),
    component: (module) => module.Skills,
  }),
  surveys: asyncComponent({
    module: () => import("./Illustrations/Surveys"),
    component: (module) => module.Surveys,
  }),
  sync_ups: asyncComponent({
    module: () => import("./Illustrations/SyncUps"),
    component: (module) => module.SyncUps,
  }),
  talent_review: asyncComponent({
    module: () => import("./Illustrations/TalentReview"),
    component: (module) => module.TalentReview,
  }),
  team: asyncComponent({
    module: () => import("./Illustrations/Team"),
    component: (module) => module.Team,
  }),
  yes_and: asyncComponent({
    module: () => import("./Illustrations/YesAnd"),
    component: (module) => module.YesAnd,
  }),
};

export const IllustrationDictionaryKeys = objectKeys(IllustrationMap);
